import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

export class InternalAuditProcedure extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'internalAudit'}
            title={ t('support.procedure.P13.title') }
            exportTitle={ t('support.procedure.P13.exportTitle') }
            exportFileName={'internalAudit.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (InternalAuditProcedure);
